import { createSlice } from '@reduxjs/toolkit';
import { t_billing_process } from 'types';
import { filterBill, getOptionYear, searchBill } from './thunk';

interface InitialState {
  optionInvoice: string[];
  loadE1: boolean;
  itemInvoices: {
    items: t_billing_process[];
    totalItems: number;
  };
  paymentAdded: number;
  paymentNoAdd: number;
}

const initalState: InitialState = {
  optionInvoice: [],
  loadE1: false,
  itemInvoices: {
    items: [],
    totalItems: 0,
  },
  paymentAdded: 0,
  paymentNoAdd: 0,
};

const slice = createSlice({
  name: 'payout',
  initialState: initalState,
  reducers: {
    startLoading(state) {
      return { ...state, loadE1: true };
    },
    resetData() {
      return {
        optionInvoice: [],
        loadE1: false,
        itemInvoices: {
          items: [],
          totalItems: 0,
        },
        paymentAdded: 0,
        paymentNoAdd: 0,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOptionYear.fulfilled, (state, action) => ({ ...state, optionInvoice: action.payload ?? [] }));
    builder.addCase(searchBill.fulfilled, (state, action) => ({
      ...state,
      itemInvoices: action.payload.bills,
      paymentAdded: action.payload.paymentAdded,
      paymentNoAdd: action.payload.paymentNoAdd,
      loadE1: false,
    }));
    builder.addCase(searchBill.rejected, (state, action) => ({
      ...state,
      itemInvoices: {
        items: [],
        totalItems: 0,
      },
      paymentAdded: 0,
      paymentNoAdd: 0,
      loadE1: false,
    }));
    builder.addCase(filterBill.fulfilled, (state, action) => ({
      ...state,
      itemInvoices: action.payload,
      loadE1: false,
    }));
  },
});

export const { startLoading, resetData } = slice.actions;
export default slice.reducer;
